import React from 'react';
import BuildingsGridKendo2 from '../BuildingsGridKendo2';

const Current = (props) => {

    const buildings = React.useMemo(() => (props.buildings), [props.buildings]);


    return (
        <div id="buildingsWrapper">
            {/* if buidling data, return a grid.  Else return empty fragment. */}
            {props.buildings && props.buildings.length > 0 ?
                <div>
                    <BuildingsGridKendo2 setCenterAndZoom={props.setCenterAndZoom} setBuildingMarker={props.setBuildingMarker} buildings={buildings} />
                    <div id="notes">
                        Notes:
                        <p>1) Buildings shown in the table represent the estimated buildings impacted by current, forecasted, or scenario stage as selected by the user. Additional buildings may be impacted outside the displayed inundatio0n and reach extnet.</p>
                        <p>2) All elevation values are in NAVD88 feet.</p>
                    </div>
                </div>
                :
                <div>
                    No Impacted Buildings
                </div>
            }
        </div>
        );
    };
    
export default Current;


// WEBPACK FOOTER //
// ./src/components/Buildings2/index.js